import {
  useAssets,
  useAllItems,
  useWriteContext,
} from "../../vendor/src/features/remotion-editor/editor/utils/use-context";
import { enterGroupMember } from "../../vendor/src/features/remotion-editor/editor/state/actions/select-group";
/** Audio compounds expose sound members, not canvas alignment or visual animation controls. */
export function AudioMergeMembers({
  groupId,
  ids,
}: {
  groupId: string;
  ids: string[];
}) {
  const { assets } = useAssets(),
    { items } = useAllItems(),
    { setState } = useWriteContext();
  return (
    <section className="border-b border-sys-style-neutral-light p-4">
      <h3 className="text-sm font-semibold">병합 음성 · {ids.length}개</h3>
      <p className="mt-2 text-xs text-gray-500">
        각 음성의 타이밍과 음량을 유지합니다. 아래 음성을 선택해 따로
        조절할 수 있습니다. 상단 음성 생성·교체 메뉴에서 병합을 유지한 채 교체할 수 있습니다. 가려진 앞뒤 구간은 그룹 구간에 맞춰 자르기로 정리하고, 다른 소리나 부모 구간을 바꾸지 않는 새 길이를 적용할 수 있습니다.
      </p>
      <ul className="mt-3 flex flex-col gap-2">
        {ids.map((id, index) => {
          const item = items[id];
          const asset = item && "assetId" in item ? assets[item.assetId] : null;
          return (
            <li key={id}>
              <button
                type="button"
                className="w-full rounded border p-2 text-left text-sm"
                onClick={() =>
                  setState({
                    commitToUndoStack: false,
                    update: (state) => enterGroupMember(state, groupId, id),
                  })
                }
              >
                {asset?.filename ?? `음성 ${index + 1}`}
              </button>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
